module.exports = {"150824100":"海流图镇","150824101":"乌加河镇","150824102":"德岭山镇","150824103":"石哈河镇","150824104":"甘其毛都镇","150824105":"温更镇","150824200":"呼鲁斯太苏木","150824201":"川井苏木","150824202":"巴音乌兰苏木","150824203":"新忽热苏木","150824400":"牧羊海牧场","150824401":"同和太种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150824.json
// module id = 417
// module chunks = 0